import {Button} from '@mui/material';
import ShareModal from 'components/Modal/SahreModal/ShareModal';
import styles from 'assets/css/shareModal.module.css';
import ShareBtn from 'assets/img/shareBtn.svg';

const Index = ({patientId}) => {
  return (
    <ShareModal patientId={patientId}>
      <Button className={styles.shareBtn_container}>
        <img src={ShareBtn} alt='' style={{width: '18px', height: '18px'}} />
      </Button>
    </ShareModal>
  );
};

export default Index;
